export const SHIPMENT_DETAILS_TEST_IDS = {
  SHIPMENT_DETAILS_SHEET: "shipment-details-sheet",
  SHIPMENT_DETAILS_SKELETON: "shipment-details-skeleton",
  SHIPMENT_DETAILS_SECTION_ORGANISATION: "shipment-details-section-organisation",
  SHIPMENT_DETAILS_SECTION_SERVICE: "shipment-details-section-service",
  SHIPMENT_DETAILS_SECTION_PROVIDERS: "shipment-details-section-providers",
  SHIPMENT_DETAILS_SECTION_SCHEDULE: "shipment-details-section-schedule",
  SHIPMENT_DETAILS_SECTION_PACKING_LIST: "shipment-details-section-packing-list",
  SHIPMENT_DETAILS_SECTION_ATTACHMENTS: "shipment-details-section-attachments",
  SHIPMENT_DETAILS_ORG_TITLE: "shipment-details-organisation-title",
  SHIPMENT_DETAILS_ORG_SHIPPER: "shipment-details-organisation-shipper",
  SHIPMENT_DETAILS_ORG_PAYMENT_LOCATION: "shipment-details-organisation-payment-location",
  SHIPMENT_DETAILS_ORG_CREATED_BY: "shipment-details-organisation-created-by",
  SHIPMENT_DETAILS_ORG_CREATED_BY_EMAIL: "shipment-details-organisation-created-by-email",
  SHIPMENT_DETAILS_ORG_CREATED_AT: "shipment-details-organisation-created-at",
  SHIPMENT_DETAILS_ORG_QUICK_REQUEST_NUMBER: "shipment-details-organisation-quick-request-number",
  SHIPMENT_DETAILS_ORG_BOOKED_BY_SYSTEM: "shipment-details-organisation-booked-by-system",
  SHIPMENT_DETAILS_ORG_INITIAL_REQUESTOR: "shipment-details-organisation-initial-requestor",
  SHIPMENT_DETAILS_ORG_INITIAL_REQUEST_NUMBER: "shipment-details-organisation-initial-request-number",
  SHIPMENT_DETAILS_ORG_INVOICE_LOCATION: "shipment-details-organisation-invoice-location",
  SHIPMENT_DETAILS_ORG_COST_CENTER: "shipment-details-organisation-cost-center",
  SHIPMENT_DETAILS_ORG_REASON_CODE_GROUP: "shipment-details-organisation-reason-code-group",
  SHIPMENT_DETAILS_ORG_REASON_CODE: "shipment-details-organisation-reason-code",
  SHIPMENT_DETAILS_ORG_CUSTOM_FIELD_1: "shipment-details-organisation-custom-field-1",
  SHIPMENT_DETAILS_ORG_CUSTOM_FIELD_2: "shipment-details-organisation-custom-field-2",
  SHIPMENT_DETAILS_ORG_CUSTOM_FIELD_3: "shipment-details-organisation-custom-field-3",
  SHIPMENT_DETAILS_ORG_LONG_FIELD: "shipment-details-organisation-long-field",
  SHIPMENT_DETAILS_ORG_ADDITIONAL_COMMENTS: "shipment-details-organisation-additional-comments",
  SHIPMENT_DETAILS_ORG_COST_RECOVERY: "shipment-details-organisation-cost-recovery",
  SHIPMENT_DETAILS_ORG_COST_RECOVERY_FIELD_1: "shipment-details-organisation-cost-recovery-field-1",
  SHIPMENT_DETAILS_ORG_COST_RECOVERY_FIELD_2: "shipment-details-organisation-cost-recovery-field-2",
  SHIPMENT_DETAILS_SERVICE_FREIGHT_MODES: "shipment-details-service-freight-modes",
  SHIPMENT_DETAILS_SERVICE_REQUIREMENT: "shipment-details-service-requirement",
  SHIPMENT_DETAILS_SERVICE_LEVEL: "shipment-details-service-level",
  SHIPMENT_DETAILS_SERVICE_INCOTERMS: "shipment-details-service-incoterms",
  SHIPMENT_DETAILS_SERVICE_INCOTERM_INSTRUCTIONS: "shipment-details-service-incoterm-instructions",
  SHIPMENT_DETAILS_SERVICE_INSURANCE: "shipment-details-service-insurance",
  SHIPMENT_DETAILS_SERVICE_INSURANCE_INSTRUCTIONS: "shipment-details-service-insurance-instructions",
  SHIPMENT_DETAILS_SERVICE_CUSTOMS_BROKER: "shipment-details-service-customs-broker",
  SHIPMENT_DETAILS_SERVICE_WINNING_PROVIDER: "shipment-details-service-winning-provider",
  SHIPMENT_DETAILS_SERVICE_SPECIAL_REQUIREMENTS: "shipment-details-service-special-requirements",
  SHIPMENT_DETAILS_PROVIDERS_LIST: "shipment-details-providers-list",
  SHIPMENT_DETAILS_SCHEDULE_TABLE: "shipment-details-schedule-table",
  SHIPMENT_DETAILS_SCHEDULE_FIRST_PICKUP: "shipment-details-schedule-first-pickup",
  SHIPMENT_DETAILS_SCHEDULE_LAST_DELIVERY: "shipment-details-schedule-last-delivery",
  SHIPMENT_DETAILS_SCHEDULE_PARTIES: "shipment-details-schedule-parties",
  SHIPMENT_DETAILS_SCHEDULE_CONSIGNEE: "shipment-details-schedule-consignee",
  SHIPMENT_DETAILS_SCHEDULE_NOTIFY_PARTY: "shipment-details-schedule-notify-party",
  SHIPMENT_DETAILS_SCHEDULE_MULTISTOP_INSTRUCTIONS: "shipment-details-schedule-multistop-instructions",
  SHIPMENT_DETAILS_SCHEDULE_CLEARANCE: "shipment-details-schedule-clearance",
  SHIPMENT_DETAILS_SCHEDULE_EXPORT_CLEARANCE: "shipment-details-schedule-export-clearance",
  SHIPMENT_DETAILS_SCHEDULE_EXPORT_CLEARANCE_INSTRUCTIONS: "shipment-details-schedule-export-clearance-instructions",
  SHIPMENT_DETAILS_SCHEDULE_TRANSIT_CLEARANCE: "shipment-details-schedule-transit-clearance",
  SHIPMENT_DETAILS_SCHEDULE_TRANSIT_CLEARANCE_INSTRUCTIONS: "shipment-details-schedule-transit-clearance-instructions",
  SHIPMENT_DETAILS_SCHEDULE_IMPORT_CLEARANCE: "shipment-details-schedule-import-clearance",
  SHIPMENT_DETAILS_SCHEDULE_IMPORT_CLEARANCE_INSTRUCTIONS: "shipment-details-schedule-import-clearance-instructions",
  SHIPMENT_DETAILS_SCHEDULE_MILEAGE: "shipment-details-schedule-mileage",
  SHIPMENT_DETAILS_PACKING_SUMMARY: "shipment-details-packing-summary",
  SHIPMENT_DETAILS_PACKING_TOTAL_WEIGHT: "shipment-details-packing-total-weight",
  SHIPMENT_DETAILS_PACKING_TOTAL_CBM: "shipment-details-packing-total-cbm",
  SHIPMENT_DETAILS_PACKING_TOTAL_UNITS: "shipment-details-packing-total-units",
  SHIPMENT_DETAILS_PACKING_GOODS_ESTIMATED: "shipment-details-packing-goods-estimated",
  SHIPMENT_DETAILS_PACKING_GOODS_FINALIZED: "shipment-details-packing-goods-finalized",
  SHIPMENT_DETAILS_PACKING_TABLE: "shipment-details-packing-table",
  SHIPMENT_DETAILS_ATTACHMENTS_LIST: "shipment-details-attachments-list",
  SHIPMENT_DETAILS_ATTACHMENTS_EMPTY: "shipment-details-attachments-empty",
  SHIPMENT_DETAILS_DOWNLOAD_ALL_ATTACHMENTS: "shipment-details-download-all-attachments",
} as const;

export const shipmentDetailsTestId = {
  providerCard: (companyId: number) => `shipment-details-providers-card-${companyId}`,
  scheduleStop: (stopIndex: number, part: string) => `shipment-details-schedule-stop-${stopIndex}-${part}`,
  packingRow: (rowIndex: number, part: string) => `shipment-details-packing-row-${rowIndex}-${part}`,
  freightMode: (modeKey: string) => `shipment-details-service-freight-mode-${modeKey}`,
  specialRequirement: (reqKey: string) => `shipment-details-service-special-requirement-${reqKey}`,
  attachment: (fileId: string | number) => `shipment-details-attachment-${fileId}`,
  field: (base: string, part: "label" | "value") => `${base}-${part}`,
};
